import { BaseDataModel } from "@domain/CRM/BaseDataModel";

/** A sampling rig (trailer). Sourced from the Airtable "Rigs" table; the portal only needs
 *  identity + display name (e.g. "RIG-12") for the scheduling create picker + shift cards. */
export class Rig extends BaseDataModel {
	name!: string;
}
